import { render, staticRenderFns } from "./footer-button.vue?vue&type=template&id=d89a5e26&scoped=true&"
import script from "./footer-button.vue?vue&type=script&lang=js&"
export * from "./footer-button.vue?vue&type=script&lang=js&"
import style0 from "./footer-button.vue?vue&type=style&index=0&id=d89a5e26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89a5e26",
  null
  
)

export default component.exports